// extracted by mini-css-extract-plugin
module.exports = {"buy-banner-wrapper":"product-buy-banner_buy-banner-wrapper__ov4Xo","drawer-wrapper":"product-buy-banner_drawer-wrapper__9ptEz"};